import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, MultiAutocomplete, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { toAppliedAgreementIds } from './ConnectToAgreementsSelect.utils';
export const GetConnectToAgreementsSelectTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export function ConnectToAgreementsSelect(props) {
    const { agreements, isLoading, isError, onSelectionApplied, testId } = props;
    const { t } = useLocaleKeys('components.managePaymentMethods.connectToAgreements');
    const { ConnectToAgreementsSelectTestIds } = useMemo(()=>GetConnectToAgreementsSelectTID(testId), [
        testId
    ]);
    const [committedIds, setCommittedIds] = useState([]);
    const value = useMemo(()=>committedIds.map((id)=>{
            var _agreements_find;
            return (_agreements_find = agreements.find((agreement)=>agreement.id === id)) !== null && _agreements_find !== void 0 ? _agreements_find : {
                id,
                name: id
            };
        }), [
        committedIds,
        agreements
    ]);
    const onApply = (selected)=>{
        const ids = toAppliedAgreementIds(selected);
        setCommittedIds(ids);
        onSelectionApplied(ids);
    };
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 12,
        testId: ConnectToAgreementsSelectTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx(MultiAutocomplete, {
                options: agreements,
                value: value,
                onApply: onApply,
                getOptionId: (option)=>option.id,
                getOptionLabel: (option)=>option.name,
                isLoading: isLoading,
                isError: isError,
                errorText: t.error(),
                label: t.title(),
                placeholder: t.selectAgreement(),
                applyLabel: t.apply(),
                testId: ConnectToAgreementsSelectTestIds.Dropdown(),
                bi: {
                    name: 'connect_to_agreement'
                }
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                children: t.overdueRetryNote()
            })
        ]
    });
}
